module.exports = __webpack_public_path__ + "img/image-avatar.aeacd4d1.png";